module.exports = __webpack_public_path__ + "img/art_tsumeri.bb582666.png";